import { render, staticRenderFns } from "./AddAdvertiser.vue?vue&type=template&id=5bf79e74&"
import script from "./AddAdvertiser.vue?vue&type=script&lang=js&"
export * from "./AddAdvertiser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports